export class Database {
    constructor() {
        this.name = 'carData';
        this.version = 1;
        this.storeName = 'cars';
    }
    async openDb() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.name, this.version);
            request.onerror = () => reject(new Error('Failed to open database'));
            request.onsuccess = () => {
                this.db = request.result;
                resolve();
            };
            request.onupgradeneeded = () => {
                this.db = request.result;
                const objectStore = this.db.createObjectStore(this.storeName, { keyPath: 'id', autoIncrement: false });
                objectStore.createIndex('id', 'id');
            };
        });
    }
    async addCarData(dbKey, carData) {
        if (!this.db) {
            console.error("Tried to add car data when no database was open.");
            return;
        }
        const store = this.db.transaction([this.storeName], 'readwrite').objectStore(this.storeName);
        const request = store.put({ id: dbKey, carData }); // OK
        return new Promise((resolve, reject) => {
            request.onerror = () => reject(new Error('Failed to add car data'));
            request.onsuccess = (event) => resolve(event.target.result);
        });
    }
    async getCarData(dbKey) {
        if (!this.db) {
            console.error("Tried to add car data when no database was open.");
            return;
        }
        const store = this.db.transaction([this.storeName], 'readwrite').objectStore(this.storeName);
        const request = store.get(dbKey);
        return new Promise((resolve, reject) => {
            request.onerror = () => reject(new Error('Failed to get car data'));
            request.onsuccess = (event) => resolve(event.target.result);
        });
    }
}
export default new Database();
